(function () {
  'use strict';

  function localiseGermanPageLinks(root) {
    if (!document.documentElement.lang || document.documentElement.lang.toLowerCase().indexOf('de') !== 0) return;

    (root || document).querySelectorAll('a[href^="/pages/"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('/de/') === 0 || href.indexOf('/fr/') === 0) return;
      link.setAttribute('href', '/de' + href);
    });
  }

  function initialise() {
    localiseGermanPageLinks(document);

    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('a[href^="/pages/"]')) localiseGermanPageLinks(node.parentNode || node);
          else localiseGermanPageLinks(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
